import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import { AuthContextProvider } from './context/authContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import reportWebVitals from './reportWebVitals';
import AppInitializer from './AppInitializer';
import { initObservability } from './observability';
import { watchForDeploy } from './reloadOnDeploy';

initObservability();
watchForDeploy();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
        <GoogleOAuthProvider clientId="244499796755-b49gi67rvqo6ikqi2oma4ncv7sihg2i9.apps.googleusercontent.com">
            <AuthContextProvider>
                {/* <GoogleOAuthProvider clientId="586971958872-7d3u65e8n0kj4pi7lfi4gigm783b0h2i.apps.googleusercontent.com"> */}
                <AppInitializer />
            </AuthContextProvider>
        </GoogleOAuthProvider>
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
